<form class="flex justify-center">
    <!-- <input
        #inputEl
        *ngFor="let input of inputsForm.controls; let i = index"
        (focus)="handleFocus($event)"
        (blur)="onTouched?.()"
        (keypress)="handleKeyPress($event, i)"
        (input)="handleInput()"
        (keydown)="handleKeyDown($event, i)"
        (paste)="handlePaste($event, i)"
        [formControl]="$any(input)"
        [attr.autocomplete]="i === 0 ? 'one-time-code' : null"
        type="text"
        inputmode="numeric"
        class="size-12 text-lg text-center rounded-lg border border-solid border-[#D1D1D1] focus:outline-none"
    /> -->
    <input 
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        maxlength="6"
        autocomplete="one-time-code"
        [formControl]="inputsForm"
        class="font-['Roboto'] text-[#333333] text-center text-3xl h-14 min-w-40 max-w-48 border border-solid border-[#e8e8e8] rounded-lg shadow-none focus:outline-[#737373]"
    />
</form>